import { render, staticRenderFns } from "./lightTable.vue?vue&type=template&id=6359ecdd&scoped=true"
import script from "./lightTable.vue?vue&type=script&lang=js"
export * from "./lightTable.vue?vue&type=script&lang=js"
import style0 from "./lightTable.vue?vue&type=style&index=0&id=6359ecdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6359ecdd",
  null
  
)

export default component.exports